import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=0046b5b4&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=js&"
export * from "./Scan.vue?vue&type=script&lang=js&"
import style0 from "./Scan.vue?vue&type=style&index=0&id=0046b5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046b5b4",
  null
  
)

export default component.exports